module.exports=function(scope){ return `curl -X GET "https://your.internal.zoomserver.instance.url/session-token"
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/bash/session-token.bash.tpl